export const NO_COMPANY_ACCESS = "NO_COMPANY_ACCESS";
export const NO_MENU_ACCESS = "NO_MENU_ACCESS";
